// import {toAbsoluteUrl} from '../../../helpers'

export function FallbackView() {
  return (
    <div className='splash-screen'>
      {/* <img src={toAbsoluteUrl('/media/logos/Cause favicon.png')} alt='Start logo' style={{width: '10px'}} /> */}
      <span>Loading ...</span>
    </div>
  )
}
